import { IEtfBackend } from 'api/etf';
import classNames from 'classnames';
import { EtfPageSection, EtfPageSectionDefinitions } from '../model';
import styles from './settings-content.module.scss';

export interface EtfPageSettingsContentProps {
	section: EtfPageSection;
	etf: IEtfBackend;
}

export const EtfPageSettingsContent = (props: EtfPageSettingsContentProps) => {
	return (
		<ul className={styles.container}>
			{
				EtfPageSectionDefinitions.map(def => (
					props.section === def.section
						? (
							<li key={def.section} className={classNames(styles.item, styles.active)}>
								<i className={def.iconClass}></i>
								{def.title}
							</li>
						)
						: (
							<a key={def.section} className={classNames(styles.item, styles.inactive)} href={def.hrefFactory(props.etf)}>
								<i className={def.iconClass}></i>
								{def.title}
							</a>
						)
				))
			}
		</ul>
	)
}